import React from "react";

class Fee extends React.Component {
    render() {
        return (
            <div className="container-fluid">
                <div className="animated">
                    Fee
                </div>
            </div>
        );
    }
}

export default Fee;



// WEBPACK FOOTER //
// ./src/views/pages/fee/index.js